import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DescriptionIcon from '@mui/icons-material/Description';
import Alert from "@mui/material/Alert";
import Snackbar from '@mui/material/Snackbar';

import { RequestButton } from "../style/button";
import { BoxSpaceCenter } from '../style/box';
import { postDownloadFile } from "../func/api";
import { BaseDialog } from "./base_dialog";

export default function DownloadExcelDialog({ earthquake, report_dir }) {
    const [open, setOpen] = useState(false);
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertSeverity, setAlertSeverity] = useState("success");


    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSendApproval = async () => {
        try {
                const payload = {
                    earthquake: earthquake,
                    report_dir: report_dir
                };
                const response = await postDownloadFile("api/download_file_s3", payload);
                handleClose();
                const blob = response.data;
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "reports.zip");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setAlertMessage("報告書のダウンロードが完了しました。");
                setAlertSeverity("success");
            } catch (error) {
                console.error("報告書のダウンロードに失敗しました。：", error);
                
                setAlertMessage("報告書のダウンロードに失敗しました。");
                setAlertSeverity("error");
            } finally {
                // Alert を表示
                setAlertOpen(true);
            }
            };

    return (
        <>
            <BoxSpaceCenter>
                <RequestButton startIcon={<DescriptionIcon />} onClick={handleClickOpen}>
                    報告書ダウンロード
                </RequestButton>
                <BaseDialog
                    open={open}
                    onClose={handleClose}
                    title="報告書ダウンロード"
                    message={"報告書のダウンロードを行います。\nよろしいですか？"}
                    onConfirm={handleSendApproval}
                    confirmText='ダウンロード'
                    cancelText='キャンセル'
                />
            </BoxSpaceCenter>
            <Snackbar
                open={alertOpen}
                autoHideDuration={3000}
                onClose={() => setAlertOpen(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }} // 右上に表示
            >
                <Alert severity={alertSeverity} onClose={() => setAlertOpen(false)}>
                    {alertMessage}
                </Alert>
            </Snackbar>
        </>
    );
}
